// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"3d0b8ede","195":"ff9bfdd3","446":"5909dc32","453":"71900a67","581":"c5fff41f","602":"a5b859ac","798":"0bea76cd","914":"245df115","933":"646f6552","991":"e544fc4f"}[chunkId] + ".chunk.js";
};